export default __webpack_public_path__ + "static/media/vignitusLogo.db850e03.png";